<template>
  <layout-bottom-sheet
    ref="bottomSheet"
    bottom-sheet-class="install-app"
  >
    <template #header>
      <span class="title">
        {{ getContent(popupsData, defaultLocalePopupsData, 'installApp.howToInstall') }}
      </span>
    </template>

    <modal-content-install-app />

    <template #footer>
      <button-base
        type="gray"
        size="md"
        @click="close"
      >
        {{ getContent(layoutData, defaultLocaleLayoutData, 'buttons.cancel') }}
      </button-base>
    </template>
  </layout-bottom-sheet>
</template>

<script setup lang="ts">
import type { IBottomSheetComponent } from '@skeleton/core/types';

const globalStore = useGlobalStore();
const { getContent } = useProjectMethods();

const {
  layoutData,
  defaultLocaleLayoutData,
  popupsData,
  defaultLocalePopupsData,
} = storeToRefs(globalStore);

const bottomSheet = ref<Maybe<IBottomSheetComponent>>();

const close = (): void => {
  bottomSheet.value!.close();
};

const open = (): void => {
  bottomSheet.value!.open();
};

defineExpose({
  open,
  close,
});
</script>
